module.exports = __webpack_public_path__ + "img/tailwindcss.3323dd02.svg";